import moment from 'moment';
import { matchPath } from 'react-router-dom';
import queryString from 'query-string';
import {
    ScheduleType as ScheduleTypeConstants,
    ExchangeType as ExchangeTypeConstants,
    AllocationType as AllocationTypeConstants,
    Frequency as FrequencyConstants,
    BlockRecommendAnExchange,
    DateFormat,
    NoEditSpawnStatuses
} from './constants';
import { getPrimaryAccount } from '../../../../utils/sessionUtil';

export const isMobile = () => {
    return window.screen.width <= 991
}

export const isFreezeUser = ( freezes = [] ) => {
    const block = Boolean(freezes.find((item) => BlockRecommendAnExchange.includes(item.toLowerCase())));
    return block;
}

export const capitalizeText = (text) =>{
    return text && text.toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
}

export const initState = () => {
    const context = window.sessionStorage.getItem('recommend-an-exchange');
    if (context) {
        return JSON.parse(context);
    }
    return getInitialData();
};

export const getInitialData = () => {
    return {
        from: {
            exchangeType: undefined,
            allocationType: '',
            scheduleType: ScheduleTypeConstants.onetime,
            total: 0,
            pools: [],
            frequency: undefined,
            startDate: undefined,
            numberOfExchanges: undefined,
            endDate: undefined,
        },
        to: {
            pools: []
        },
        confirmation: {},
        spawns: undefined,
    }
};

export const mapSingleExchangeToContext = (exchange = {}) => {
    const context = getInitialData();
    context.from.scheduleType = ScheduleTypeConstants.onetime;
    if (exchange.exchangeType.toLowerCase() === 'custom exchange' ) {
        context.from.exchangeType = ExchangeTypeConstants.custom;
    } else if(exchange.exchangeType.toLowerCase() === 'reallocation') {
        context.from.exchangeType = ExchangeTypeConstants.reallocation;
    }
    
    if (context.from.exchangeType === ExchangeTypeConstants.custom) {
        if (exchange.instructionType === 'DOLLAR') {
            context.from.allocationType = AllocationTypeConstants.dollar
        } else if (exchange.instructionType === 'PERCENT') {
            context.from.allocationType = AllocationTypeConstants.percentage
        } else if (exchange.instructionType === 'UNITS') {
            context.from.allocationType = AllocationTypeConstants.unit
        }
    } else if (context.from.exchangeType === ExchangeTypeConstants.reallocation) {
        context.from.allocationType = AllocationTypeConstants.dollar;
    }
    
    // set 'from' total
    context.from.total = exchange.exchangeFrom && exchange.exchangeFrom.reduce((acc, item) => acc + Number(item.value || 0), 0);
    // map 'from' pools
    const fromPools = exchange.exchangeFrom && exchange.exchangeFrom.map((item) => {
        return {
            poolId: item.poolId,
            poolName: item.pool,
            pricePerUnit: item.pricePerUnit,
            isRise: item.rise,
            availableBalance: item.availableBalance,
            currentNAV: item.currentnav,
            percentage: item.percentage,
            unit: item.unit,
            value: item.value,
            dollar: Number(item.value || 0)
        }
    });
    context.from.pools = fromPools;

    const toPools = exchange.exchangeTo && exchange.exchangeTo.map((item) => {
        return {
            investmentOption: item.pool,
            poolId: item.poolId,
            currentNAV: item.currentnav,
            availableBalance: item.availableBalance,
            pricePerUnit: item.pricePerUnit,
            isRise: item.rise,
            value: item.value,
            percentage: item.percentage && Number(item.percentage),
            unit: item.unit
        }
    });
    context.to.pools = toPools;
    return context;
};

export const mapSpawnExchangeToContext  = (exchange = {}) => { 
    const context = mapSingleExchangeToContext(exchange);
    context.from.startDate = moment(exchange.exchangeStartDate, 'x').format(DateFormat);
    context.from.endDate = null;
    return context;
}

const checkSpawnApproved = (spawn) => {
    return NoEditSpawnStatuses.includes(spawn.status.toLowerCase())
}


export const mapRecurringExchangeToContext = (exchange) => {
    const context = mapSingleExchangeToContext(exchange);
    context.from.scheduleType = ScheduleTypeConstants.recurring;
    switch (exchange.frequency.toLowerCase()) {
        case 'weekly schedule':
            context.from.frequency = FrequencyConstants.weekly;
            break;
        case 'monthly schedule':
            context.from.frequency = FrequencyConstants.monthly;
            break;
        case 'quarterly schedule':
            context.from.frequency = FrequencyConstants.quaterly;
            break;
    }
    const spwn = exchange && exchange.spawns && exchange.spawns.find((spawn) => {
        return spawn.status.toLowerCase() === 'not scheduled'
    });
    context.from.startDate = spwn && spwn.exchangeDate && moment(spwn.exchangeDate, 'x').format('MM/DD/YYYY');
    context.from.exchangeStartDate = moment(exchange.exchangeStartDate).format('MM/DD/YYYY');
    context.from.numberOfExchanges = exchange.noOfExchangesRemaining;
    context.from.endDate = moment(exchange.exchangeCompleteDate).format('MM/DD/YYYY');
    context.from.isSpawnApproved = checkSpawnApproved(exchange.spawns[0])
    context.spawns = exchange.spawns
    return context;
};



const calPercentage = (data) => {
    var amt = 0;
    data.forEach((obj, i) => {
        amt += ((obj.availableBalance * Number(obj.percentage)) / 100)
    })
    return amt
}

const calDollar = (data) => {
    var amt = 0;
    data.forEach((obj, i) => {
        amt += Number(obj.value)
    })
    return amt
}

const calUnits = (data) => {
    var amt = 0;
    data.forEach((obj, i) => {
        amt += (obj.unit * Number(obj.pricePerUnit))
    })
    return amt
}

export const calTotalAmount = (from) => {
    if (from) {
        var val = 0;
        switch (from.allocationType) {
            case 'percentage': return val = calPercentage(from.pools);
            case 'dollar': return val = calDollar(from.pools);
            case 'unit': return val = calUnits(from.pools);
        }
        return val
    }
    return 0
}

export const calculateIntialParams = ({ location }) => {
    let scheduleTypeParam = null;
    let exhchangeTypeParam = null;
    let isReturnedParam = false;
    if (location?.state) {
        // This is only for TIFF exchange to navigate to recommend-an-exchange with one-time or recurring schedule type
        scheduleTypeParam = location.state.scheduleType; // onetime/recurring
        exhchangeTypeParam = scheduleTypeParam === ScheduleTypeConstants.recurring ? ExchangeTypeConstants.custom : null
        isReturnedParam = Boolean(scheduleTypeParam) || location.state.isReturned;
    }
    // match path for getting exchange id from url, match will be null is path don't match
    const match = matchPath(location?.pathname, {
        path: "/investments/recommend-an-exchange/:id",
        exact: false,
        strict: false
    });
    const matchSpawn = matchPath(location?.pathname, {
        path: "/investments/recommend-an-exchange/:id/spawn/:spawnid",
        exact: false,
        strict: false
    })
    const matchRecommendFrom = matchPath(location?.pathname, {
        path: "/investments/recommend-an-exchange/:id/from",
        exact: true,
        strict: false
    });
    const exchangeIdParam = match && match.params.id; // if match is null then exchange id can be null;
    const exchPendingSpawnIdParam = matchSpawn && matchSpawn.params.spawnid;
    const isRecommendFromParam = Boolean(matchRecommendFrom);
    const isNewParam = exchangeIdParam === 'NEW'; // to identify if exchange is new or view/updating existing exchange
    const query = queryString.parse(location?.search);
    const editParam = query && query.edit === 'true'; // If user is in edit mode in the new exchange flow. This is not related to view and edit case.
    const typeParam = query && query.type; // If view and edit activity flow we need type to identify single or recurring or tiff exchange

    return {
        exchangeIdParam,
        exchPendingSpawnIdParam,
        isRecommendFromParam,
        isNewParam,
        editParam,
        typeParam,
        scheduleTypeParam,
        exhchangeTypeParam,
        isReturnedParam,
    }
}

// New access level Read only with exchage privilege
export const isReadOnlyWithExchangeRole = () => {
    let primaryAccount = getPrimaryAccount();
    const { access, readOnlyWithExchange=false } = primaryAccount.role;
    return (access === "Read Only" && readOnlyWithExchange === "true")
}